import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  InputGroup,
  Button,
  Modal,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FacilityBaseUrl } from "../Routes/BaseUrl";

const DOCTOR_SUBCATEGORIES = [
  { subCategory: "Modern Medicine", code: 1 },
  { subCategory: "Dentist", code: 2 },
  { subCategory: "Homoeopathy", code: 3 },
  { subCategory: "Ayurveda", code: 4 },
  { subCategory: "Unani", code: 5 },
  { subCategory: "Siddha", code: 6 },
  { subCategory: "Sowa-Rigpa", code: 7 },
  { subCategory: "Nutrician", code: 8 },
  { subCategory: "Dietician", code: 9 },
];

const NURSE_SUBCATEGORIES = [
  { subCategory: "RANM", code: 8 },
  { subCategory: "RN", code: 9 },
  { subCategory: "RN & RM", code: 10 },
  { subCategory: "RLHV", code: 11 },
];

const SPECIALIZATIONS = {
  "Modern Medicine#1": [
    { specialization: "Cardiologist", code: "CAR" },
    { specialization: "Neurologist", code: "NEU" },
    { specialization: "Orthopaedic Surgeon", code: "ORT" },
    { specialization: "Gastroenterologist", code: "GAS" },
    { specialization: "Dermatologist", code: "DER" },
    { specialization: "Pediatrician", code: "PED" },
    { specialization: "Radiologist", code: "RAD" },
    { specialization: "Psychiatrist", code: "PSY" },
    { specialization: "Endocrinologist", code: "END" },
    { specialization: "Pulmonologist", code: "PUL" },
    { specialization: "Nephrologist", code: "NEP" },
    { specialization: "Oncologist", code: "ONC" },
    { specialization: "ENT Specialist", code: "ENT" },
    { specialization: "Ophthalmologist", code: "OPH" },
    { specialization: "Urologist", code: "URO" },
    { specialization: "General Surgeon", code: "GSU" },
    { specialization: "Plastic Surgeon", code: "PLS" },
    { specialization: "Emergency Medicine", code: "EMR" },
    { specialization: "Family Physician", code: "FAM" },
    { specialization: "Rheumatologist", code: "RHE" },
  ],
  "Dentist#2": [
    { specialization: "Orthodontist", code: "ORTH" },
    { specialization: "Periodontist", code: "PERI" },
    { specialization: "Endodontist", code: "ENDO" },
    { specialization: "Prosthodontist", code: "PROS" },
  ],
  "Homoeopathy#3": [
    { specialization: "General Homoeopathy", code: "HOM" },
    { specialization: "Pediatric Homoeopathy", code: "PHO" },
  ],
  "Ayurveda#4": [
    { specialization: "Panchakarma Specialist", code: "PAN" },
    { specialization: "Kayachikitsa", code: "KAY" },
  ],
  "Unani#5": [
    { specialization: "General Unani", code: "UNA" },
  ],
  "Siddha#6": [
    { specialization: "Siddha Medicine", code: "SID" },
  ],
  "Sowa-Rigpa#7": [
    { specialization: "Traditional Sowa-Rigpa", code: "SOW" },
  ],
  "RANM#8": [
    { specialization: "General Nursing", code: "GN" },
  ],
  "RN#9": [
    { specialization: "Registered Nurse Specialist", code: "RNS" },
  ],
  "RN & RM#10": [
    { specialization: "Midwifery Specialist", code: "MID" },
  ],
  "RLHV#11": [
    { specialization: "Rural Health Specialist", code: "RHS" },
  ],
};

export const GeneralInfoForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    mobileNumber: "",
    emailId: "",
    dateOfBirth: "",
    role: "",
    category: "",
    subCategory: "",
    specialization: "",
    healthcareId: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [verified, setVerified] = useState({ mobile: false, email: false });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpType, setOtpType] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [storedMobileOtp, setStoredMobileOtp] = useState(null);

  useEffect(() => {
    let interval;
    if (showOtpModal && timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [showOtpModal, timer]);

  const getSubcategories = () => {
    if (formData.category === "Doctor") return DOCTOR_SUBCATEGORIES;
    if (formData.category === "Nurse") return NURSE_SUBCATEGORIES;
    return [];
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required";
    if (!/^[0-9]{10}$/.test(formData.mobileNumber)) newErrors.mobileNumber = "Mobile number must be 10 digits";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) newErrors.emailId = "Invalid email";
    if (!formData.dateOfBirth.trim()) newErrors.dateOfBirth = "Date of birth is required";
    if (!formData.role) newErrors.role = "Role is required";
    if (!formData.category) newErrors.category = "Category is required";
    if (!formData.subCategory) newErrors.subCategory = "Sub Category is required";
    if (!formData.specialization) newErrors.specialization = "Specialization is required";
    if (!/^[a-zA-Z0-9._-]+$/.test(formData.healthcareId || "")) newErrors.healthcareId = "Invalid healthcare ID";
    if (!formData.password) newErrors.password = "Password is required";
    if (
      formData.password &&
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(formData.password)
    ) {
      newErrors.password = "Password must include uppercase, lowercase, number, special character";
    }
    if (!formData.confirmPassword) newErrors.confirmPassword = "Confirm password is required";
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendOtp = async (type) => {
    const value = type === "mobile" ? formData.mobileNumber : formData.emailId;

    if (type === "mobile" && !/^[0-9]{10}$/.test(value)) {
      toast.error("Please enter valid mobile number");
      return;
    }
    if (type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      toast.error("Please enter valid email");
      return;
    }

    try {
      const payload = type === "mobile" ? { mobileNumber: value } : { email: value };
      const response = await axios.post(`${FacilityBaseUrl.trim()}/doctor/send-otp`, payload, {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });

      if (response.data?.statusCode === 200 || response.data?.success) {
        if (type === "mobile" && response.data?.data?.mobileOtp) {
          setStoredMobileOtp(response.data.data.mobileOtp);
        }
        setOtpType(type);
        setOtp(Array(6).fill(""));
        setTimer(30);
        setCanResend(false);
        setShowOtpModal(true);
        toast.success(`OTP sent to ${type}`);
      } else {
        toast.error(response.data?.message || "Failed to send OTP");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send OTP");
    }
  };

  const verifyOtp = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      toast.error("Enter 6-digit OTP");
      return;
    }

    try {
      if (otpType === "email") {
        const response = await axios.post(
          `${FacilityBaseUrl.trim()}/doctor/verify-otp`,
          { type: "email", otp: enteredOtp, value: formData.emailId },
          { withCredentials: true, headers: { "Content-Type": "application/json" } },
        );

        if (response.data?.statusCode === 200 || response.data?.success) {
          setVerified((prev) => ({ ...prev, email: true }));
          setShowOtpModal(false);
          toast.success("Email verified");
        } else {
          toast.error(response.data?.message || "Invalid OTP");
        }
      } else {
        if (storedMobileOtp && enteredOtp === storedMobileOtp) {
          setVerified((prev) => ({ ...prev, mobile: true }));
          setStoredMobileOtp(null);
          setShowOtpModal(false);
          toast.success("Mobile verified");
        } else {
          toast.error("Invalid mobile OTP");
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "OTP verification failed");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    if (!verified.mobile) {
      toast.error("Please verify mobile number");
      return;
    }
    if (!verified.email) {
      toast.error("Please verify email");
      return;
    }

    const payload = {
      fullName: formData.fullName,
      emailId: formData.emailId,
      mobileNumber: formData.mobileNumber,
      dateOfBirth: formData.dateOfBirth,
      category: formData.category,
      subCategory: formData.subCategory.includes("#")
        ? formData.subCategory.split("#")[1]
        : formData.subCategory,
      role: String(formData.role),
      hprId: formData.healthcareId,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
    };

    try {
      const response = await axios.post(
        `${FacilityBaseUrl.trim()}/facility/facilityRegister`,
        payload,
        { withCredentials: true, headers: { "Content-Type": "application/json" } },
      );

      if (response.status === 200) {
        if (response.data?.token) {
          localStorage.setItem("token", response.data.token);
        }
        toast.success(response.data?.message || "Facility registered successfully");
        navigate("/FacilityList");
      } else {
        toast.error(response.data?.message || "Registration failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Registration failed");
    }
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const nextOtp = [...otp];
    nextOtp[index] = value.slice(-1);
    setOtp(nextOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`facility-otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  return (
    <Card border="light" className="bg-white shadow-sm">
      <Card.Body>
        <h5 className="mb-4">Register Facility</h5>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  value={formData.fullName}
                  onChange={(e) => setFormData((prev) => ({ ...prev, fullName: e.target.value }))}
                  isInvalid={!!errors.fullName}
                />
                <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Mobile Number</Form.Label>
                <InputGroup>
                  <Form.Control
                    value={formData.mobileNumber}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        mobileNumber: e.target.value.replace(/[^0-9]/g, ""),
                      }))
                    }
                    isInvalid={!!errors.mobileNumber}
                  />
                  <Button type="button" variant="outline-primary" onClick={() => sendOtp("mobile")} disabled={verified.mobile}>
                    {verified.mobile ? <FontAwesomeIcon icon={faCheckCircle} className="text-success" /> : "Verify"}
                  </Button>
                </InputGroup>
                {errors.mobileNumber && <div className="text-danger mt-1">{errors.mobileNumber}</div>}
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <Form.Control
                    value={formData.emailId}
                    onChange={(e) => setFormData((prev) => ({ ...prev, emailId: e.target.value }))}
                    isInvalid={!!errors.emailId}
                  />
                  <Button type="button" variant="outline-primary" onClick={() => sendOtp("email")} disabled={verified.email}>
                    {verified.email ? <FontAwesomeIcon icon={faCheckCircle} className="text-success" /> : "Verify"}
                  </Button>
                </InputGroup>
                {errors.emailId && <div className="text-danger mt-1">{errors.emailId}</div>}
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control
                  placeholder="DD-MM-YYYY"
                  value={formData.dateOfBirth}
                  onChange={(e) => setFormData((prev) => ({ ...prev, dateOfBirth: e.target.value }))}
                  isInvalid={!!errors.dateOfBirth}
                />
                <Form.Control.Feedback type="invalid">{errors.dateOfBirth}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Roles</Form.Label>
            <div className="d-flex flex-column gap-2">
              <Form.Check
                type="radio"
                name="facilityRole"
                label="I am a Facility Manager / Administrator"
                checked={String(formData.role) === "2"}
                onChange={() => setFormData((prev) => ({ ...prev, role: "2" }))}
              />
              <Form.Check
                type="radio"
                name="facilityRole"
                label="I am a Healthcare Professional & Facility Manager"
                checked={String(formData.role) === "3"}
                onChange={() => setFormData((prev) => ({ ...prev, role: "3" }))}
              />
            </div>
            {errors.role && <div className="text-danger mt-1">{errors.role}</div>}
          </Form.Group>

          <Row>
            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select
                  value={formData.category}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      category: e.target.value,
                      subCategory: "",
                      specialization: "",
                    }))
                  }
                  isInvalid={!!errors.category}
                >
                  <option value="">Select Category</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Nurse">Nurse</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.category}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Sub Category</Form.Label>
                <Form.Select
                  value={formData.subCategory}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, subCategory: e.target.value, specialization: "" }))
                  }
                  disabled={!formData.category}
                  isInvalid={!!errors.subCategory}
                >
                  <option value="">Select Sub Category</option>
                  {getSubcategories().map((item) => (
                    <option key={item.code} value={`${item.subCategory}#${item.code}`}>
                      {item.subCategory}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.subCategory}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Specialization</Form.Label>
                <Form.Select
                  value={formData.specialization}
                  onChange={(e) => setFormData((prev) => ({ ...prev, specialization: e.target.value }))}
                  disabled={!formData.subCategory}
                  isInvalid={!!errors.specialization}
                >
                  <option value="">Select Specialization</option>
                  {(SPECIALIZATIONS[formData.subCategory] || []).map((item) => (
                    <option key={item.code} value={`${item.specialization}#${item.code}`}>
                      {item.specialization}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.specialization}</Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Healthcare Professional ID / Username</Form.Label>
                <InputGroup>
                  <Form.Control
                    value={formData.healthcareId}
                    onChange={(e) => setFormData((prev) => ({ ...prev, healthcareId: e.target.value }))}
                    isInvalid={!!errors.healthcareId}
                  />
                  <InputGroup.Text>@hpr.abdm</InputGroup.Text>
                </InputGroup>
                {errors.healthcareId && <div className="text-danger mt-1">{errors.healthcareId}</div>}
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Create Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))}
                    isInvalid={!!errors.password}
                  />
                  <Button type="button" variant="outline-secondary" onClick={() => setShowPassword((prev) => !prev)}>
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </Button>
                </InputGroup>
                {errors.password && <div className="text-danger mt-1">{errors.password}</div>}
              </Form.Group>
            </Col>

            <Col md={4} className="mb-3">
              <Form.Group>
                <Form.Label>Confirm Password</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData((prev) => ({ ...prev, confirmPassword: e.target.value }))}
                    isInvalid={!!errors.confirmPassword}
                  />
                  <Button type="button" variant="outline-secondary" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                    <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                  </Button>
                </InputGroup>
                {errors.confirmPassword && <div className="text-danger mt-1">{errors.confirmPassword}</div>}
              </Form.Group>
            </Col>
          </Row>

          <Button type="submit" variant="primary" className="w-100 mt-2">
            Submit
          </Button>
        </Form>
      </Card.Body>

      <Modal centered show={showOtpModal} onHide={() => setShowOtpModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Verify {otpType === "mobile" ? "Mobile" : "Email"} OTP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center gap-2 mb-3">
            {otp.map((digit, index) => (
              <Form.Control
                key={index}
                id={`facility-otp-${index}`}
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                style={{ width: "42px", textAlign: "center" }}
              />
            ))}
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <small className="text-muted">
              {timer > 0 ? `Resend OTP in ${timer}s` : "Didn't receive OTP?"}
            </small>
            {canResend && (
              <Button variant="link" className="p-0" onClick={() => sendOtp(otpType)}>
                Resend OTP
              </Button>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={verifyOtp}>Verify OTP</Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};
